(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[169],{

/***/ "PeCK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/frameworks/download-links-list/DownloadLinksList.jsx + 1 modules
var DownloadLinksList = __webpack_require__("j65c");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// CONCATENATED MODULE: ./src/client/components/lines/product-information-summary-line/ProductInformationSummaryLine.jsx
var __jsx = react_default.a.createElement;



var ProductInformationSummaryLine_ProductInformationSummaryLine = function ProductInformationSummaryLine(_ref) {
  var downloadLabel = _ref.downloadLabel,
      id = _ref.id,
      factSheetUrl = _ref.resort.factSheetUrl,
      resortId = _ref.resortId,
      text = _ref.text;

  if (!factSheetUrl) {
    return null;
  }

  var links = [{
    label: downloadLabel,
    target: '_blank',
    trackingData: {
      categoryGA: 'resort',
      actionGA: 'CTA_download_factsheet',
      labelGA: resortId
    },
    url: factSheetUrl
  }];
  return __jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line Line-DownloadLinksList",
    id: id
  }, __jsx(DownloadLinksList["a" /* DownloadLinksList */], {
    className: "bg-white py-20 shadow-bottom",
    links: links,
    text: text
  }));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/product-information-summary/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (ProductInformationSummaryLine_ProductInformationSummaryLine);

/***/ }),

/***/ "j65c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ DownloadLinksList_DownloadLinksList; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/utils/classnames/classnames.utils.js
var classnames_utils = __webpack_require__("C/y5");

// EXTERNAL MODULE: ./src/client/components/utils/icon/icons.js
var icons = __webpack_require__("SPKZ");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/frameworks/dynamic-link/DynamicLink.jsx
var DynamicLink = __webpack_require__("i5Mr");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// CONCATENATED MODULE: ./src/client/components/frameworks/download-links-list/DownloadLinksList.themes.js
var themes = {
  "default": {
    thRoot: 'flex flex-col sm:flex-row gap-20 sm:items-center',
    thLabel: 'flex flex-col sm:flex-row sm:flex-1 gap-5 sm:gap-10 items-center text-center',
    thLabelIconSize: '1.25rem',
    thText: 'font-bold',
    thList: 'flex flex-col sm:flex-row gap-10 shrink-0 flex-start',
    thListItem: 'flex gap-5 justify-center',
    thListItemIcon: 'shrink-0',
    thLink: ' inline-flex flex-row-reverse font-bold items-center text-black hocus:text-black-active text-12 transition-color duration-250 ease-in underline'
  },
  lite: {
    thRoot: 'flex flex-col sm:flex-row gap-10 sm:gap-20 sm:items-center',
    thLabel: 'flex flex-row items-center gap-5',
    thLabelIconSize: '1rem',
    thText: 'font-bold',
    thList: 'flex flex-col sm:flex-row gap-10 shrink-0',
    thListItem: 'flex items-center gap-5 text-sienna w-full sm:w-auto',
    thListItemIcon: 'shrink-0',
    thListItemIconSize: '1.3rem',
    thLink: ' inline-block font-bold items-center text-black hocus:text-black-active text-14 transition-color duration-250 ease-in underline w-full'
  }
};
// CONCATENATED MODULE: ./src/client/components/frameworks/download-links-list/DownloadLinksList.jsx

var __jsx = react_default.a.createElement;








var DownloadLinksList_DownloadLinksList = function DownloadLinksList(_ref) {
  var className = _ref.className,
      _ref$links = _ref.links,
      links = _ref$links === void 0 ? [] : _ref$links,
      text = _ref.text,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme;
  var track = Object(useTracking["a" /* useTracking */])();

  if (!links.length) {
    return null;
  }

  var _themes$theme = themes[theme],
      thLabel = _themes$theme.thLabel,
      thLabelIconSize = _themes$theme.thLabelIconSize,
      thLink = _themes$theme.thLink,
      thList = _themes$theme.thList,
      thListItem = _themes$theme.thListItem,
      thListItemIcon = _themes$theme.thListItemIcon,
      thListItemIconSize = _themes$theme.thListItemIconSize,
      thRoot = _themes$theme.thRoot,
      thText = _themes$theme.thText;
  return __jsx("section", {
    className: Object(classnames_utils["a" /* classnames */])(thRoot, className)
  }, !!text && __jsx("div", {
    className: thLabel
  }, __jsx(Icon["a" /* Icon */], {
    className: "shrink-0 text-sienna",
    name: icons["a" /* ICONS */].DOWNLOAD,
    width: thLabelIconSize
  }), __jsx(Text["a" /* Text */], {
    className: thText,
    text: text
  })), __jsx("ul", {
    className: thList
  }, links.map(function (_ref2) {
    var iconName = _ref2.iconName,
        label = _ref2.label,
        _onClick = _ref2.onClick,
        target = _ref2.target,
        trackingData = _ref2.trackingData,
        url = _ref2.url;
    return url && label && __jsx("li", {
      className: thListItem,
      key: label
    }, __jsx(Icon["a" /* Icon */], {
      className: thListItemIcon,
      name: iconName,
      width: thListItemIconSize
    }), __jsx(DynamicLink["a" /* default */], {
      className: thLink,
      onClick: function onClick() {
        _onClick === null || _onClick === void 0 ? void 0 : _onClick();
        trackingData && track(trackingData);
      },
      target: target,
      url: url
    }, label));
  })));
};

/***/ })

}]);